import React from 'react';
export class StoreData {
  isAnalyticsVisible: { [key: string ]: boolean } = {}
  setIsAnalyticsVisible: Function = () => {}

}

export const StoreContext = React.createContext(new StoreData());
